export const mapAnnotationForGeneration = (annotation) => ({
  type: annotation.type,
  content: annotation.content || annotation.name,
});
